module.exports = __webpack_public_path__ + "img/PP_Sword_0177.f16ec8d5.png";